module.exports = __webpack_public_path__ + "fc054c99948a9c68e9348be8812fb70e.png";